import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import MultiButton, {createButton} from "../components/MultiButton";

function ConfirmThreeButtons(
    {
        open,
        confirmTitle,
        confirmText,
        confirmText2,
        onConfirm,
        onSecondConfirm,
        onCancel,
        labelConfirm = "yes",
        labelCancel = "no",
        labelSecondConfirm = "yes",
        translateConfirmTexts = true
    }) {

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr(labelCancel), onCancel, 'outlined', false));
        buttons.push(createButton(Tr(labelConfirm), onConfirm, undefined, false));
        buttons.push(createButton(Tr(labelSecondConfirm), onSecondConfirm, undefined, false));
        return buttons;
    }

    return (
        <Dialog
            title={!!confirmTitle ? Tr(confirmTitle) : Tr('attention')}
            open={open}
            titleCentered
            onClose={onCancel}
            dialogActions={<MultiButton buttons={getButtons()} justify='flex-end' />}
        >
            {!!confirmText && <Typography variant='body1'>
                {translateConfirmTexts ? Tr(confirmText) : confirmText}
            </Typography>}
            {!!confirmText2 && <Typography variant='body1'>
                {translateConfirmTexts ? Tr(confirmText2) : confirmText2}
            </Typography>}

        </Dialog>
    )
}

ConfirmThreeButtons.propTypes = {
    open: PropTypes.bool.isRequired,
    confirmText: PropTypes.string.isRequired,
    confirmText2: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    labelConfirm: PropTypes.string,
    labelCancel: PropTypes.string,
    translateConfirmTexts: PropTypes.bool
}

export default ConfirmThreeButtons;